// src/pages/PrivacyPolicy.js

import React from "react";
import "./PrivacyPolicy.css"; // Link the CSS file

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="effective-date">Effective Date: July 31, 2025</p>

        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>stockvia.in</strong> (“we”, “our”, “Site”). We are
          committed to protecting your privacy. This Policy explains how we
          collect, use, store, and disclose personal data.
        </p>

        <h2>2. Information We Collect</h2>
        <ul>
          <li>
            Personal Information you provide voluntarily (e.g. name, email
            during newsletter form).
          </li>
          <li>
            Usage Data, such as IP addresses, browser type, device, pages
            visited, referral URLs, timestamps, using cookies and tracking.
          </li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Personalize your experience</li>
          <li>Send administrative updates or marketing (with opt-in)</li>
          <li>Detect and prevent fraud or abuse</li>
        </ul>

        <h2>4. Cookies & Tracking Technologies</h2>
        <p>
          We use cookies and similar technologies to enhance user experience and
          analyze site traffic. You can adjust your browser settings to manage
          or disable cookies.
        </p>

        <h2>5. Third-Party Services</h2>
        <ul>
          <li>Analytics tools (e.g. Google Analytics) to monitor usage</li>
          <li>
            Advertising services, including Google AdSense, which may collect
            info via cookies and device identifiers to serve relevant ads
          </li>
        </ul>

        <h2>6. Ads on Our Site</h2>
        <p>
          To display ads, we will use networks (e.g. AdSense), which may collect
          browsing information. Visitors can opt out via Google Ad Settings.
        </p>

        <h2>7. Data Sharing</h2>
        <p>
          We do not sell or rent personal information. It may be disclosed only
          when:
        </p>
        <ul>
          <li>Required by law (court orders, legal processes)</li>
          <li>Enforcing our policies or safeguarding site security</li>
        </ul>

        <h2>8. Data Security & Retention</h2>
        <p>
          We employ standard security protocols to protect data. Personal data
          is retained only as long as needed for the purposes described.
        </p>

        <h2>9. Children’s Privacy</h2>
        <p>
          Our services are not intended for users under 13 years old. We do not
          knowingly collect information from children. If discovered, such data
          will be deleted.
        </p>

        <h2>10. External Links</h2>
        <p>
          Our site may link to third-party content. We are not responsible for
          the privacy practices of those sites.
        </p>

        <h2>11. Changes to This Policy</h2>
        <p>
          We may update this Policy periodically. The “Effective Date” at the
          top will reflect changes. Continued use after any changes means
          consent to updated terms.
        </p>

        <h2>12. Contact Us</h2>
        <p>
          If you have questions or requests regarding this Policy, please
          contact us at: <br />
          <a href="mailto:your-email@stockvia.in">your-email@stockvia.in</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
